import DetailsPayments from './DetailsPayments.view';

export default DetailsPayments;
